<div class="loading_container">
    <div *ngIf="isLoading" class="loading-user-spinner">
        <mat-progress-spinner [diameter]="44" mode="indeterminate" class="spinner-class">
        </mat-progress-spinner>
    </div>
</div>